/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventcreatedbutsomeimagesfailedtoupload7Inputs */

const en_eventcreatedbutsomeimagesfailedtoupload7 = /** @type {(inputs: Eventcreatedbutsomeimagesfailedtoupload7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event created, but some images failed to upload`)
};

const de_eventcreatedbutsomeimagesfailedtoupload7 = /** @type {(inputs: Eventcreatedbutsomeimagesfailedtoupload7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Event wurde erstellt, aber einige Bilder konnten nicht hochgeladen werden.`)
};

/**
* | output |
* | --- |
* | "Event created, but some images failed to upload" |
*
* @param {Eventcreatedbutsomeimagesfailedtoupload7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventcreatedbutsomeimagesfailedtoupload7 = /** @type {((inputs?: Eventcreatedbutsomeimagesfailedtoupload7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventcreatedbutsomeimagesfailedtoupload7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventcreatedbutsomeimagesfailedtoupload7(inputs)
	return de_eventcreatedbutsomeimagesfailedtoupload7(inputs)
});
export { eventcreatedbutsomeimagesfailedtoupload7 as "eventCreatedButSomeImagesFailedToUpload" }